export enum RequestLoginLinkOutcome {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  RESEND_TOO_SOON = 'RESEND_TOO_SOON',
  LOCKED = 'LOCKED',
}

export enum VerifyLoginOutcome {
  AUTHENTICATED = 'AUTHENTICATED',
  SELECTION_REQUIRED = 'SELECTION_REQUIRED',
  REFUSED = 'REFUSED',
}

export enum VerifyLoginRefusalReason {
  EXPIRED = 'EXPIRED',
  ALREADY_CONSUMED = 'ALREADY_CONSUMED',
  INVALID = 'INVALID',
  LOCKED = 'LOCKED',
  WRONG_CODE_TOKEN = 'WRONG_CODE_TOKEN',
  SUBJECT_NOT_AMONG_RESOLVED = 'SUBJECT_NOT_AMONG_RESOLVED',
}

export interface RequestLoginLinkOutput {
  outcome: RequestLoginLinkOutcome;
  requestId: string;
  retryAt?: string | null;
}

export interface LoginSession {
  subjectId: string;
  sessionToken: string;
}

export interface LoginSubject {
  subjectId: string;
  displayName: string;
}

export interface LoginRefusal {
  reason: VerifyLoginRefusalReason;
  retryAt?: string | null;
}

export interface VerifyLoginOutput {
  outcome: VerifyLoginOutcome;
  session?: LoginSession | null;
  subjects?: LoginSubject[] | null;
  refusal?: LoginRefusal | null;
}

export type PasswordlessVerifyPath = 'link' | 'code';

export type VerifyRefusalAction =
  | 'request-fresh'
  | 'generic'
  | 'locked'
  | 'keep-code'
  | 'stay-picker';
